import React from 'react';
import { usePermissions } from '../context/PermissionContext';
import { Card, Result } from 'antd';
import { StopOutlined } from '@ant-design/icons';
import Dashboard from '../layouts/Dashboard';

const PermissionGuard = ({ requiredPermission, children }) => {
  const { permissions, loading } = usePermissions();

  // If no permission required, render children directly
  if (!requiredPermission) {
    return children;
  }

  // While permissions are loading, show nothing (avoid flash of denied page)
  if (loading) {
    return null;
  }

  // Check if user has the required permission
  const hasPermission = permissions[requiredPermission];

  if (!hasPermission) {
    return (
      <Dashboard title="HR Management System">
        <Card className="mt-3">
          <Result
            icon={<StopOutlined style={{ color: '#ff4d4f' }} />}
            title="You don't have permission to access this page"
            subTitle="Please contact your administrator if you believe this is an error."
          />
        </Card>
      </Dashboard>
    );
  }

  return children;
};

export default PermissionGuard;
